
// export const baseUrl = "http://192.168.0.23:8081/api"
export const baseUrl = 'https://pongo.net.cn/api'


export const bottomLink = [
  {
    title: "数字孪生平台",
    content: [
      {
        title: "PONGO",
        url: "",
      },
      {
        title: "PONGO PROD",
        url: "",
      },
      {
        title: "PONGO 下载",
        url: "",
      },
      {
        title: "PONGO PROD 下载",
        url: "",
      },
    ],
  },
  {
    title: "数字孪生产品",
    content: [
      {
        title: "定制化三维建模",
        url: "",
      },
      {
        title: "交互式电子手册IETM",
        url: "",
      },
      {
        title: "数字孪生产品开发",
        url: "",
      },
      {
        title: "工艺仿真模拟",
        url: "",
      },
    ],
  },
  {
    title: "数字孪生+",
    url: "/digital_twin",
    content: [
      {
        title: "数字孪生+智能制造",
        url: "/create",
      },
      {
        title: "数字孪生+园区",
        url: "/factory",
      },
      {
        title: "数字孪生+港口",
        url: "/dock",
      },
      {
        title: "数字孪生+能源",
        url: "/energy",
      },
    ],
  },
  {
    title: "数字化升级",
    content: [
      {
        title: "物联网LOT",
        url: "",
      },
      {
        title: "产线信息化",
        url: "",
      },
      {
        title: "产线自动化",
        url: "",
      },
      {
        title: "旧产线改造",
        url: "",
      },
    ],
  },
];

export const bottomContact = [
  {
    title: "Tel.",
    content: "15863078552 邵经理",
    imgUrl: require("../assets/footer/资源 56.png"),
  },
  {
    title: "E-mail",
    content: "admin@vp3d.cn",
    imgUrl: require("../assets/footer/资源 54.png"),
  },
  {
    title: "QQ",
    content: "726991519",
    imgUrl: require("../assets/footer/资源 60.png"),
  },
  {
    title: "Add.",
    content: "青岛市市北区周口路97号中航科技园",
    imgUrl: require("../assets/footer/资源 55.png"),
  },
];

export const ponGoIntroduce = [
  "PONGO是一款利用三维数字化技术，实现项目从数字化映",
  "射到决策自洽全生命周期解决方案",
];

export const ponGoNav = [
  {
    title: "PONGO",
    to: "/pongo",
  },
  {
    title: "PONGO PROD",
    to: "/pongo",
  },
  {
    title: "PONGO 下载",
    to: "/pongo",
  },
  {
    title: "PONGO PROD 下载",
    to: "/pongo",
  },
];

export const support = [
  {
    // ow water
    id: 1,
    image: require("../assets/image/logo/网站3-59.png"),
    imageColor: require("../assets/image/logo/网站3-34.png"),
    bg: require("../assets/image/logo/资源 386.png"),
    isImage: true,
  },
  {
    // 中车
    id: 2,
    isImage: true,
    image: require("../assets/image/logo/网站3-63.png"),
    imageColor: require("../assets/image/logo/网站3-39.png"),
  },
  {
    // 海大
    id: 3,
    isImage: true,
    image: require("../assets/image/logo/网站3-36.png"),
    imageColor: require("../assets/image/logo/网站3-43.png"),
  },
  {
    // 华仁
    id: 4,
    isImage: true,
    image: require("../assets/image/logo/网站3-71.png"),
    imageColor: require("../assets/image/logo/网站3-47.png"),
  },
  {
    // 高测
    id: 5,
    isImage: true,
    image: require("../assets/image/logo/网站3-75.png"),
    imageColor: require("../assets/image/logo/网站3-51.png"),
  },
  {
    // mesnac
    id: 6,
    isImage: true,
    image: require("../assets/image/logo/网站3-79.png"),
    imageColor: require("../assets/image/logo/网站3-55.png"),
  },
  {
    // 海行云
    id: 7,
    isImage: true,
    image: require("../assets/image/logo/网站3-60.png"),
    imageColor: require("../assets/image/logo/网站3-33.png"),
  },
  {
    // flo
    id: 8,
    isImage: true,
    image: require("../assets/image/logo/网站3-64.png"),
    imageColor: require("../assets/image/logo/网站3-40.png"),
  },
  {
    // 金盾
    id: 9,
    isImage: true,
    image: require("../assets/image/logo/网站3-68.png"),
    imageColor: require("../assets/image/logo/网站3-44.png"),
  },
  {
    // hidrostal
    id: 10,
    isImage: true,
    image: require("../assets/image/logo/网站3-72.png"),
    imageColor: require("../assets/image/logo/网站3-49.png"),
  },
  {
    // 海尔
    id: 11,
    isImage: true,
    image: require("../assets/image/logo/网站3-76.png"),
    imageColor: require("../assets/image/logo/网站3-52.png"),
  },
  {
    // 海信
    id: 12,
    isImage: true,
    image: require("../assets/image/logo/资源 393-8.png"),
    imageColor: require("../assets/image/logo/资源 392-8.png"),
  },
  {
    // hishing
    id: 13,
    isImage: true,
    image: require("../assets/image/logo/网站3-61.png"),
    imageColor: require("../assets/image/logo/网站3-37.png"),
  },
  {
    // 卡萨帝
    id: 14,
    isImage: true,
    image: require("../assets/image/logo/资源 397-8.png"),
    imageColor: require("../assets/image/logo/资源 391-8.png"),
  },
  {

    // made hope
    id: 15,
    isImage: true,
    image: require("../assets/image/logo/网站3-69.png"),
    imageColor: require("../assets/image/logo/网站3-45.png"),
  },
  {
    // 电科
    id: 16,
    isImage: true,
    image: require("../assets/image/logo/网站3-73.png"),
    imageColor: require("../assets/image/logo/网站3-35.png"),
  },
  {
    // stroller
    id: 17,
    isImage: true,
    image: require("../assets/image/logo/网站3-77.png"),
    imageColor: require("../assets/image/logo/网站3-53.png"),
  },
  {
    // creek
    id: 18,
    isImage: true,
    image: require("../assets/image/logo/creek-无颜色.png"),
    imageColor: require("../assets/image/logo/creek-有颜色.png"),
  },
  {
    // qust
    id: 19,
    isImage: true,
    image: require("../assets/image/logo/网站3-62.png"),
    imageColor: require("../assets/image/logo/网站3-38.png"),
  },
  {
    // s&j
    id: 20,
    isImage: true,
    image: require("../assets/image/logo/网站3-67.png"),
    imageColor: require("../assets/image/logo/网站3-42.png"),
  },
  {
    // 海洋所
    id: 21,
    isImage: true,
    image: require("../assets/image/logo/海洋研究所-无颜色.png"),
    imageColor: require("../assets/image/logo/海洋研究所-有颜色.png"),
  },
  {
    // 地质
    id: 22,
    isImage: true,
    image: require("../assets/image/logo/网站3-74.png"),
    imageColor: require("../assets/image/logo/网站3-50.png"),
  },
  {
    // 中铁
    id: 23,
    isImage: true,
    image: require("../assets/image/logo/网站3-78.png"),
    imageColor: require("../assets/image/logo/网站3-54.png"),
  },
  {
    // 不认识
    id: 24,
    isImage: true,
    image: require("../assets/image/logo/资源 394-8.png"),
    imageColor: require("../assets/image/logo/资源 395-8.png"),
  },
];

export const serverNav = [
  {
    title: "延展服务",
    toTitle: "expand",
    content: ["定制化三维建模", "虚实连通", "虚拟调试"],
    to: ["/create", "/factory", "/dock", "/energy"],
  },
  {
    title: "产品数字化交互",
    toTitle: "/digital_twin",
    content: ["数字化说明书", "产品培训", "远程维护", "产品仿真优化"],
    to: ["/create", "/factory", "/dock", "/energy"],
  },
  {
    title: "数字孪生+",
    toTitle: "/digital_twin",
    content: [
      "数字孪生+智能制造",
      "数字孪生+港口",
      "数字孪生+能源",
      "数字孪生+园区",
    ],
    to: ["/create", "/dock", "/energy", "/factory"],
  },
  {
    title: "数字化服务",
    toTitle: "/digital_twin",
    content: ["物联网LOT", "产线信息化", "产线自动化", "旧产线改造"],
    to: ["/create", "/factory", "/dock", "/energy"],
  },
];

export const collapseArray = [
  {
    id: 1,
    title: "数字孪生+智能制造",
    icon: require("../assets/image/资源 272.png"),
    iconSelected: require("../assets/image/资源 265.png"),
    content:
      "将信息技术广泛应用到城市的规划，服务和管理过程中，通过市民，企业政府，第三方组织的共同参与，将城市各类资源进行科学配置，提升城市的竞争力和吸引力，实现创新低碳的产业经济，绿色友好的城市环境，高效科学的政府治理，最终实现市民高品质的生活目标",
  },
  {
    id: 2,
    title: "数字孪生+园区",
    icon: require("../assets/image/资源 273.png"),
    iconSelected: require("../assets/image/资源 262.png"),
    content:
      "将信息技术广泛应用到城市的规划，服务和管理过程中，通过市民，企业政府，第三方组织的共同参与，将城市各类资源进行科学配置，提升城市的竞争力和吸引力，实现创新低碳的产业经济，绿色友好的城市环境，高效科学的政府治理，最终实现市民高品质的生活目标",
  },
  {
    id: 3,
    title: "数字孪生+港口",
    icon: require("../assets/image/资源 277.png"),
    iconSelected: require("../assets/image/资源 264.png"),
    content:
      "将信息技术广泛应用到城市的规划，服务和管理过程中，通过市民，企业政府，第三方组织的共同参与，将城市各类资源进行科学配置，提升城市的竞争力和吸引力，实现创新低碳的产业经济，绿色友好的城市环境，高效科学的政府治理，最终实现市民高品质的生活目标",
  },
  {
    id: 4,
    title: "数字孪生+能源",
    icon: require("../assets/image/资源 274.png"),
    iconSelected: require("../assets/image/资源 260.png"),
    content:
      "将信息技术广泛应用到城市的规划，服务和管理过程中，通过市民，企业政府，第三方组织的共同参与，将城市各类资源进行科学配置，提升城市的竞争力和吸引力，实现创新低碳的产业经济，绿色友好的城市环境，高效科学的政府治理，最终实现市民高品质的生活目标",
  },
];

export const homeValue = [
  {
    title: "CBD智慧城市运管平台",
    icon: require("../assets/image/3.4-智能制造-未点击.png"),
    iconSelected: require("../assets/image/3.4-智能制造-点击.png"),
    content: "实现区域内商业业态，人员管理，交通什么..",
  },
  {
    title: "CBD智慧城市运管平台",
    icon: require("../assets/image/3.4-港口-未点击.png"),
    iconSelected: require("../assets/image/3.4-港口-点击.png"),
    content: "实现区域内商业业态，人员管理，交通什么..",
  },
  {
    title: "CBD智慧城市运管平台",
    icon: require("../assets/image/3.4-冶金-未点击.png"),
    iconSelected: require("../assets/image/3.4-冶金-点击.png"),
    content: "实现区域内商业业态，人员管理，交通什么..",
  },
  {
    title: "CBD智慧城市运管平台",
    icon: require("../assets/image/3.4-园区-未点击.png"),
    iconSelected: require("../assets/image/3.4-园区-点击.png"),
    content: "实现区域内商业业态，人员管理，交通什么..",
  },
];

export const titleIndex = [
  {
    title: "服务范围",
    content:
      "利用三维数字化技术，实现项目从数字化映射到决策自洽全生命周期解决方案",
  },
  {
    title: "模型案例应用",
    content:
      "矢量利用数字孪生技术，结合行业特点定制六大行业解决方案，助力企业更安全、更智能",
  },
  {
    title: "海量免费模型任你选",
    content:
      "矢量利用数字孪生技术，结合行业特点定制六大行业解决方案，助力企业更安全、更智能",
  },
  {
    title: "核心优势",
    content:
      "矢量利用数字孪生技术，结合行业特点定制六大行业解决方案，助力企业更安全、更智能",
  },
  {
    title: "感谢每一位客户支持",
    content: "您的需求是我们坚持的动力",
  },
];

export const titleHomePage = [
  {
    title: "数字孪生全生命周期解决方案",
    content:
      "利用三维数字化技术，实现项目从数字化映射到决策自洽全生命周期解决方案",
  },
  {
    title: "数字孪生+四大行业解决方案",
    content:
      "矢量利用数字孪生技术，结合行业特点定制六大行业解决方案，助力企业更安全、更智能",
  },
  {
    title: "他们都在各自行业中发挥着价值",
    content: "为品牌及中小型企业提供定制化的行业数字孪生解决方案",
  },
];

export const titleCreate = [
  {
    title: "行业痛点",
    content:
      "利用三维数字化技术，实现项目从数字化映射到决策自洽全生命周期解决方案",
    item: [
      {
          title:'数字化映射',
          img: require('../assets/image/资源243.png'),
          content:'数字孪生能通过感知数据的分析结果与动态行业词典相结合进行自我学习更新，并根据已知的物理对象运行模式在数字空间中预测、模拟并调试潜在未发掘的及未来可能出现的物理对象的新运行模式'
      },
      {
          title:'自我学习',
          img: require('../assets/image/资源244.png'),
          content:'数字孪生能通过感知数据的分析结果与动态行业词典相结合进行自我学习更新，并根据已知的物理对象运行模式在数字空间中预测、模拟并调试潜在未发掘的及未来可能出现的物理对象的新运行模式'
      },
      {
          title:'分析诊断',
          img: require('../assets/image/资源 245.png'),
          content:'数字孪生能通过感知数据的分析结果与动态行业词典相结合进行自我学习更新，并根据已知的物理对象运行模式在数字空间中预测、模拟并调试潜在未发掘的及未来可能出现的物理对象的新运行模式'
      },
      {
          title:'决策自洽',
          img: require('../assets/image/资源 246.png'),
          content:'数字孪生能通过感知数据的分析结果与动态行业词典相结合进行自我学习更新，并根据已知的物理对象运行模式在数字空间中预测、模拟并调试潜在未发掘的及未来可能出现的物理对象的新运行模式'
      }
    ]
  },
  {
    title: "解决方案",
    content: "我们只有更专业，客户才能用的很放心",
  },
  {
    title: "成功案例",
    content: "助力企业通过数字孪生 更便捷的认知和管理现实世界",
  },
];

export const titleEnergy = [
  {
    title: "行业痛点",
    content:
      "利用三维数字化技术，实现项目从数字化映射到决策自洽全生命周期解决方案",
  },
  {
    title: "解决方案",
    content: "我们只有更专业，客户才能用的很放心",
  },
  {
    title: "成功案例",
    content: "助力企业通过数字孪生 更便捷的认知和管理现实世界",
  },
];

export const titleAbout = [
  {
    title: "矢量，构筑企业数字化新生态",
    content:
      "以自研数字孪生平台PONGO为核心,为企业提供全生命周期的数字化应用解决方案，助力企业在数字化时代的转型升级。",
  },
  {
    title: "服务优势",
    content:
      "利用三维数字化技术，实现项目从数字化映射到决策自洽全生命周期解决方案",
  },
  {
    title: "联系我们",
    content: "",
  },
  {
    title: "新闻动态",
    content:
      "利用三维数字化技术，实现项目从数字化映射到决策自洽全生命周期解决方案",
  },
];

export const digitalServerHeader = [
  {
    id: 1,
    name: "智能制造孪生解决方案",
    image_url: "",
    icon_url: "",
    small_title: {
      en: "DigitalTwins + create",
      ch: "数字孪生 + 智能制造",
    },
    big_title: {
      title: "智能制造孪生解决方案",
      content:
        "以三维场景为依托、生产数据为核心、生产业务为纽带，实现工厂园区、车间、流水线、设备的逐级可视，并整合各个流程节点之间的数据及信息对生产过程进行综合监管及全局分析，形成智慧工厂管理的新模式",
    },
  },
  {
    id: 2,
    name: "园区孪生解决方案",
    image_url: "",
    icon_url: "",
    small_title: {
      en: "DigitalTwins + factory",
      ch: "数字孪生 + 园区",
    },
    big_title: {
      title: "园区孪生解决方案",
      content:
        "以三维场景为依托、生产数据为核心、生产业务为纽带，实现工厂园区、车间、流水线、设备的逐级可视，并整合各个流程节点之间的数据及信息对生产过程进行综合监管及全局分析，形成智慧工厂管理的新模式",
    },
  },
  {
    id: 3,
    name: "港口孪生解决方案",
    image_url: "./image/资源117.png",
    icon_url: "./image/资源 91.png",
    small_title: {
      en: "DigitalTwins + dock",
      ch: "数字孪生 + 港口",
    },
    big_title: {
      title: "港口港口孪生解决方案",
      content:
        "以三维场景为依托、生产数据为核心、生产业务为纽带，实现工厂园区、车间、流水线、设备的逐级可视，并整合各个流程节点之间的数据及信息对生产过程进行综合监管及全局分析，形成智慧工厂管理的新模式",
    },
  },
  {
    id: 4,
    name: "能源孪生解决方案",
    image_url: "./image/资源117.png",
    icon_url: "./image/资源121.png",
    small_title: {
      en: "DigitalTwins + energy",
      ch: "数字孪生 + 能源",
    },
    big_title: {
      title: "能源孪生解决方案",
      content:
        "通过数字孪生技术，与电网企业业务、管理深度融合，不断提高数字化、网络化、智能化水平，形成的新型能源生态系统，帮助电网行业全局视角掌握电网业务管理运营",
    },
  },
];

export const barData = [
  {
    showBar: false,
    key: "/",
    title: "首页",
    children: [],
  },
  {
    key: "/digital_twin",
    title: "数字孪生+",
    children: [
      {
        key: "/trace",
        title: "数字孪生+轨道交通",
      },
      {
        key: "/city",
        title: "数字孪生+社区/城市",
      },
      {
        key: "/ocean",
        title: "数字孪生+海洋",
      },
      {
        key: "/dock",
        title: "数字孪生+港口",
      },
      {
        key: "/factory",
        title: "数字孪生+工厂",
      },
      {
        key: "/energy",
        title: "数字孪生+能源冶金",
      },
    ],
  },
  {
    title: "PONGO下载",
    key: "/pongo",
  },
  {
    title: "模型库",
    key: "/models",
  },
  // {
  //   title: "帮助中心",
  //   key: "/help",
  // },
  {
    title: "关于矢量",
    key: "/about",
  },
];

export const digitalTitle = [
  {
    title: "数字孪生前生命周期解决方案",
    value:
      "利用三维数字化技术，实现项目从数字化映射到决策自治全生命周期解决方案",
  },
  {
    title: "服务优势",
    value: "以需求为导向，提供专业的应用数字技术解决方案；",
  },
  {
    title: "合作客户",
    value:
      "矢量数字提供数字孪生技术服务，将数字孪生与行业业务深度融合，创造数字化未来。迄今为止，矢量已服务了上百个行业领军企业，并不断为全行业客户提供数字孪生解决方案",
  },
  {
    title: "服务优势",
    value: "以需求为导向，提供专业的应用数字技术解决方案；",
  },
  {
    title: "服务优势",
    value:
      "提供项目从前期设计、虚拟运转到项目设备入场监控，同时可项目运行中的数字孪生监控管理，同时PONGO还具备丰富的大数据算法库，帮助企业快速实现数字化转型",
  },
];

export const digitalSolutions = [
  {
    title: "数字化映射",
    path: "../../images/数字化映射.png",
    img: require("../assets/image/资源 525.png"),
    bg: require("../assets/image/资源 29.png"),
    content:
      "数字孪生要对物理空间进行精准的数字化复现，并通过物联网实现物理空间与数字空间之间的虚实互动。",
  },
  {
    title: "自我学习",
    path: "../../images/自我学习.png",
    img: require("../assets/image/资源 523.png"),
    bg: require("../assets/image/资源 28.png"),
    content:
      "数字孪生能通过将感知数据的分析结果与动态行业词典相结合进行自我学习更新，并根据已知的物理对象运行模式，在数字空间中预测、模拟并调试潜在未发觉的及未来可能出现的物理对象的新运行模式。",
  },
  {
    title: "分析诊断",
    path: "../../images/分析诊断.png",
    img: require("../assets/image/资源 524.png"),
    bg: require("../assets/image/资源 27.png"),
    content:
      "将数据驱动模型融入物理世界的精准仿真数字模型中，对物理空间进行全周期的动态监控，构建各类可复用的 功能模块，对所涉数据进行分析、理解，实现对物理世界的状态跟踪、分析和问题诊断等功能。",
  },
  {
    title: "决策自治",
    path: "../../images/决策自洽.png",
    img: require("../assets/image/资源 522.png"),
    bg: require("../assets/image/资源 26.png"),
    content:
      "具有“中枢神经”处理功能的模块则通过对各类智能推理结果的进一步归集、梳理与分析，实现对物理世界复杂状态的预判，并自发地提出决策性建议和预见性改造，并根据实际情况不断调整和完善自身体系。",
  },
];

export const digitalAdvantages = [
  {
    title: "数字孪生，青岛数字孪生",
    path: "",
    content:
      "深耕行业，了解行业规律，触达企业业务本质。基于客户特点，提出更有建设性的解决方案",
  },
  {
    title: "数字孪生，青岛数字孪生",
    path: "",
    content: "提供数字孪生前中后期全流程一体化执行团队",
  },
  {
    title: "数字孪生，青岛数字孪生",
    path: "",
    content: "自研平台——PONGO数字孪生平台，协助企业快速搭建数字孪生平台",
  },
  {
    title: "数字孪生，青岛数字孪生",
    path: "",
    content: "绑定式合作，成为企业的事业合作共同体，与企业共发展",
  },
];

export const digitalCustomer = [
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
  {
    name: "海尔",
    path: "../../assets/haier.png",
  },
];



export const digitalDock = [
  {
    title: "打造港口运营数字化底座",
    // imagePath: require("../assets/港口1.jpg"),
    isHover: true,
    content:
      "基于自主开发引擎，打破港口数据孤岛现状，将离散的实时监控系统、设施管理系统、智能运输系统等各类业务系统数据进行统一整合。打通港口信息流、资金流、物流、商流等各类数据，将物流公司、港口公司、船公司、货代、船代、司机、业务员等各方数据统一监管，夯实港口运营管理数字化底座，为港口运营管理提供基础    ",
  },
  {
    title: "实现港口管理统一化协作",
    // imagePath: require("../assets/港口2.gif"),
    isHover: true,
    content:
      "平台支持从对象、事件、性能等多个维度，对港口资产、人员、货物进行立体化监管，帮助用户实现统一化协作。支持即时定位港区安全事件、动态判断集装箱作业趋势、掌握港区能耗和污染治理状况，提升调度人员全局掌控能力、提升安全人员跨专业异常事件监控能力，提升运维人员多维度的设备运行保障能力，增强港区运营协同性    ",
  },
  {
    title: "辅助港口运营科学化决策",
    // imagePath: require("../assets/港口3.jpg"),
    isHover: true,
    content:
      "基于数字孪生技术实现港区物理世界在数字世界的镜像，打造可视化运营管理平台，进而为不同层级的管理和操作人员，提供从宏观到微观的港区运营视图。从安全、高效、环保等维度提供港区一张图，便于用户从繁杂的业务数据中进行管理聚焦，从而有效辅助港区提升科学化、智慧化的经营决策水平    ",
  },
];

export const digitalCreate = [
  {
    title: "1:1工厂产线映射",
    imagePath: require("../assets/image/资源 62 (2).png"),
    content:
      "通过数字孪生技术来进行精细化建模，打造整个厂区环境，从园区、车间、生产流水线、设备的逐级可视，还原工厂车间布局，生产设备模型，生产工艺等，并展示各类设备的空间位置，清晰完整地展现整个工厂环境。按照从原料入厂到成品出仓（含检验）的实际工艺流水线仿真展示生产的整体流程，表现关键设备动作、物料流向、生产流程流畅程度等；对接工艺流程系统，基于3D场景实时模拟工艺流水线的状态，如正常、故障、拥堵等。在系统中模拟展示物料、 AGV车辆聚集情况，用户可通过调节特定工艺流程参数模拟仿真工艺变化，调试生产方案，发现生产线隐含问题，提高实际生产线工作效率    ",
  },
  {
    title: "打通信息孤岛实现工厂综合性管理",
    imagePath: require("../assets/image/资源 69.png"),
    content:
      "基于数字孪生技术构建的智慧工厂，能够直观地将厂区建筑及各领域管理要素得到精准复现，并基于全域数据信息，建立一系列业务决策模型，能够实现对当前状态的评估、对过去发生问题的诊断，以及对未来趋势的预测，为业务决策提供科学依据。基于数字孪生技术打造智慧工厂，实现工厂的全要素数字化和虚拟化、生产管理实时化和可视化、设备运维协同化和智能化，助力工业企业实现数字化运营",
  },
  {
    title: "数字化巡检",
    imagePath: require("../assets/image/资源 70.png"),
    content:
      "根据需要灵活规划巡检业务，支持主动与被动等多种巡检方式，管理者可实时查看当前园区内巡检工作完成度及人员位置，或利用机器人技术模拟完成虚拟巡检，大大提升实施效率和后期可维护性。配合AR增强现实技术，在工厂内即可对设备所有信息进行掌握，提高了巡检效率及工厂数字化运营管理水平    ",
  },
  {
    title: "仓储运输管理",
    imagePath: require("../assets/image/资源 68.png"),
    content:
      "实现仓储的库区、仓库、罐区、货架、设备等的逐级可视；以仓储监控为重点，集成视频监控、出入库、库存盘点、告警等各种管理系统，构建仓储管理的监控、预警、诊断、分析一体化的数字孪生管理平台。实现AGV等运输设备实时映射监控，完成物料从仓库到产线的运输的全流程信息打通，加强企业对仓储运输的管理，减少企业物料的存储数量和周期，实现企业降本增效的目标    ",
  },
];

export const digitalFactory = [
  {
    title: "1:1工厂产线映射",
    imagePath: require("../assets/image/资源 62 (2).png"),
    content:
      "通过数字孪生技术来进行精细化建模，打造整个厂区环境，从园区、车间、生产流水线、设备的逐级可视，还原工厂车间布局，生产设备模型，生产工艺等，并展示各类设备的空间位置，清晰完整地展现整个工厂环境。按照从原料入厂到成品出仓（含检验）的实际工艺流水线仿真展示生产的整体流程，表现关键设备动作、物料流向、生产流程流畅程度等；对接工艺流程系统，基于3D场景实时模拟工艺流水线的状态，如正常、故障、拥堵等。在系统中模拟展示物料、 AGV车辆聚集情况，用户可通过调节特定工艺流程参数模拟仿真工艺变化，调试生产方案，发现生产线隐含问题，提高实际生产线工作效率    ",
  },
  {
    title: "打通信息孤岛实现工厂综合性管理",
    imagePath: require("../assets/image/资源 69.png"),
    content:
      "基于数字孪生技术构建的智慧工厂，能够直观地将厂区建筑及各领域管理要素得到精准复现，并基于全域数据信息，建立一系列业务决策模型，能够实现对当前状态的评估、对过去发生问题的诊断，以及对未来趋势的预测，为业务决策提供科学依据。基于数字孪生技术打造智慧工厂，实现工厂的全要素数字化和虚拟化、生产管理实时化和可视化、设备运维协同化和智能化，助力工业企业实现数字化运营",
  },
  {
    title: "数字化巡检",
    imagePath: require("../assets/image/资源 70.png"),
    content:
      "根据需要灵活规划巡检业务，支持主动与被动等多种巡检方式，管理者可实时查看当前园区内巡检工作完成度及人员位置，或利用机器人技术模拟完成虚拟巡检，大大提升实施效率和后期可维护性。配合AR增强现实技术，在工厂内即可对设备所有信息进行掌握，提高了巡检效率及工厂数字化运营管理水平    ",
  },
  {
    title: "仓储运输管理",
    imagePath: require("../assets/image/资源 68.png"),
    content:
      "实现仓储的库区、仓库、罐区、货架、设备等的逐级可视；以仓储监控为重点，集成视频监控、出入库、库存盘点、告警等各种管理系统，构建仓储管理的监控、预警、诊断、分析一体化的数字孪生管理平台。实现AGV等运输设备实时映射监控，完成物料从仓库到产线的运输的全流程信息打通，加强企业对仓储运输的管理，减少企业物料的存储数量和周期，实现企业降本增效的目标    ",
  },
];

export const digitalEnergy = [
  {
    title: "业务一体化管理",
    // imagePath: require("../assets/能源1.jpg"),
    // iconSelected: require('')
    icon: [0, 1, 2, 3, 4],
    content:
      "贯通内外部系统、上下游资源，提升不同专业数据共享能力，充分挖掘电网数据价值，实现电力系统不同专业的互联互通、协同发展。贯通内外部系统、上下游资源，提升不同专业数据共享能力，充分挖掘电网数据价值，实现电力系统不同专业的互联互通、协同发展    ",
  },
  {
    title: "夸竖井共享共用",
    // imagePath: require("../assets/能源2.png"),
    icon: [0, 1, 2, 3, 4],
    content:
      "依托数字孪生技术，打破各竖井限制，建立跨专业跨系统的表征指标体系，将电网业务通过业务维度、管理维度、运营维度进行贯通。依托数字孪生技术，打破各竖井限制，建立跨专业跨系统的表征指标体系，将电网业务通过业务维度、管理维度、运营维度进行贯通    ",
  },
  {
    title: "信息立体呈现",
    // imagePath: require("../assets/能源3.png"),
    icon: [0, 1, 2, 3, 4],
    content:
      "通过三维建模、视景仿真、信息集成、可视化交互等技术，提供强大的三维空间信息表达能力，构建一个电网的数字孪生体。通过三维建模、视景仿真、信息集成、可视化交互等技术，提供强大的三维空间信息表达能力，构建一个电网的数字孪生体    ",
  },
  {
    title: "多维度辅助管理",
    // imagePath: require("../assets/能源3.jpg"),
    icon: [0, 1, 2, 3, 4],
    content:
      "实现电网的地球、国家、省、市、区域、厂站、重点负荷不同层级的360°全景覆盖。有效利用海量电网运行数据、设备监测数据，实现人员车辆定位、行动轨迹、巡检路线等的可视化追溯及业务信息的历史溯源，构建可视、可查、可管、可溯的三维电网运营管理平台    ",
  },
  {
    title: "数据功能服务化",
    // imagePath: require("../assets/能源5.png"),
    icon: [0, 1, 2, 3, 4],
    content:
      "具备灵活的接口配置能力，对接各类物联数据、信息数据、空间数据及电力系统数据的集成处理能力，可集成各种接口协议。将相关系统功能进行API级的封装与集成调用，形成能力节点服务化，以电力业务视角进行数据服务，满足跨专业数据融合",
  },
];

export const successfulProjects = [
  {
    title: "某市轨道交通线网管理公司",
    content:
      "轨道交通站点可视化项目，融合车辆运行、客户服务、应急指挥、能源监控、设备设施监控等多专业数据，为应急指挥、客流疏导等提供必要的数据支撑，进一步提升地铁服务质量、降低安全风险和影响",
  },
  {
    title: "某市轨道交通线网管理公司",
    content:
      "轨道交通站点可视化项目，融合车辆运行、客户服务、应急指挥、能源监控、设备设施监控等多专业数据，为应急指挥、客流疏导等提供必要的数据支撑，进一步提升地铁服务质量、降低安全风险和影响",
  },
  {
    title: "某海洋科研机构",
    content: "某海洋科研机构综合海洋数字孪生系统，可对海洋现象进行综合推演",
  },
  {
    title: "某港口科技公司",
    content:
      "整合港口经营数据，运营数据，管理调度，物流数据，结合物联网技术，大数据分析，实现港口行业在数字孪生全要素场景下的动态数据实时驱动，全生命周期的作业仿真，实现智慧港口全面感知、智能决策    ",
  },
  {
    title: "某企业空簧组装产线项目",
    content:
      "本项目通过数字孪生技术，将企业产线1：1数字建模，实现企业从仓储，物流，生产工艺，生产监控，生产质量的数字化监控，同时平台结合大数据分析，对企业生产进行优化，提高企业生产管理水平和效率，实现了将本增效的目标；    ",
  },
  {
    title: "某市电力公司电力传送",
    content:
      "该方案针对国内重大事件，如体育赛事等，在城市全景数字孪生体中覆盖电网数据、对象运行、保电线路、天气交通赛程、保障力量、保障工作、指挥协同等的全景保电信息。基于该数字孪生系统，电力公司可实现从城市-区域-站所-设备-终端分层穿透逐级下钻，满足不用场景下的应用需求，构建可管、可视、可追踪、可参观的数字孪生平台    ",
  },
];

export const painPoints = [
  {
    title: "数字孪生，青岛数字孪生",
    order: 1,
    imagePath: "",
    content:
      "轨道交通作为日常重要交通工具，客流信息滞后易导致拥堵，无法及时限流疏导，存在安全隐患",
  },
  {
    title: "数字孪生，青岛数字孪生",
    order: 2,
    content:
      "监控系统众多，告警信息分散，故障根因追溯困难。其次，传统文字告警信息表达有限",
  },
  {
    title: "数字孪生，青岛数字孪生",
    order: 3,
    content:
      "轨道交通的系统应用多，数据分散，不能在同一个平台展示，难以基于数据实现正确决策",
  },
  {
    title: "数字孪生，青岛数字孪生",
    order: 4,
    content:
      "轨道交通范围大，对设备能耗缺乏数据展示及统计分析，存在大量能源无形浪费",
  },
  {
    title: "数字孪生，青岛数字孪生",
    order: 5,
    content:
      "随着轨道交通建设的发展，涉及的里程、站点数飞速增涨，需要管理的设备繁杂",
  },
];

export const cityPainPoints = [
  {
    title: "标准不统一，数据融合难",
    color: "#54defc",
    content:
      "社区管理依赖于各类物联网监控系统，各系统独立运行独立维护，无法实现数据的互联互通    ",
  },
  {
    title: "体系不完善，维护成本高",
    color: "#fdae60",
    content:
      "各专业领域配备专项的服务人员，且服务方式及服务标准不统一，缺乏规范化的管理体系，维护成本较高    ",
  },
  {
    title: "空间不直观，管理难度大",
    color: "#fdd360",
    content:
      "社区管理具有对象多、规模大、分布散等特点，管理需求跟社区空间无法进行关联，运维人员无法快速定位服务位置，缺乏统一的空间管理手段    ",
  },
];

export const oceanPainPoints = [
  {
    title: "数字孪生，青岛数字孪生",
    content: "涉海相关数据类型复杂，各种类型的数据格式类型不同",
  },
  {
    title: "数字孪生，青岛数字孪生",
    content:
      "海洋相关领域的研究只是停留在二维数据和热力图，不能立体地将海洋现象和数据表现出来    ",
  },
  {
    title: "数字孪生，青岛数字孪生",
    content:
      "涉海相关的企事业单位针对海洋领域研究相对专业，海洋相关的数据分布在各个事业单位中，数据源比较分散    ",
  },
  {
    title: "数字孪生，青岛数字孪生",
    content:
      "海洋相关的研究存在单一性和专业性，缺少统一叠加态的海洋环境底座，无法进行综合性的海洋活动推演    ",
  },
];

export const dockPainPoints = [
  {
    title: "故障信息单一",
    content:
      "监控系统众多，告警信息分散，故障根因追溯困难。其次，传统文字告警信息表达有限    ",
    url: require("../assets/image/资源94.png"),
  },
  {
    title: "信息数据分散",
    content:
      "轨道交通的系统应用多，数据分散，不能在同一个平台展示，难以基于数据实现正确决策    ",
    url: require("../assets/image/资源95.png"),
  },
  {
    title: "安防监控",
    content: "监控系统、门禁系统、楼宇对讲系统、防盗报警、停车管理    ",
    url: require("../assets/image/资源96.png"),
  },
  {
    title: "设备数据庞大",
    content:
      "随着轨道交通建设的发展，涉及的里程、站点数飞速增涨，需要管理的设备繁杂    ",
    url: require("../assets/image/资源97.png"),
  },
  {
    title: "能源无形浪费",
    content:
      "轨道交通范围大，对设备能耗缺乏数据展示及统计分析，存在大量能源无形浪费    ",
    url: require("../assets/image/资源98.png"),
  },
  {
    title: "客流监控滞后",
    content:
      "轨道交通作为日常重要交通工具，客流信息滞后易导致拥堵，无法及时限流疏导，存在安全隐患    ",
    url: require("../assets/image/资源99.png"),
  },
];

export const factoryPainPoints = [
  {
    title: "监控工具散 管控难度高",
    color: "#54defc",
    content:
      "工厂内监控管理系统繁多，且均独立运行分散管理，运维人员人员无法实时、全面、准确地了解现场生产情况和工序流程    ",
  },
  {
    title: "巡检工作繁 运维压力大",
    color: "#fdae60",
    content:
      "工厂具有厂区规模大、生产设备多、监控设备散等特点，巡检主要依赖人力，压力大成本高，运维人员无法及时发现问题    ",
  },
  {
    title: "生产系统多 统筹管理难",
    color: "#fdd360",
    content:
      "生产数据数据分散在不同管理平台，管理决策需要统筹全局数据进行分析，而分散割裂的数据无法支撑管理者进行高效决策    ",
  },
  {
    title: "仓储物料多 批次追溯难",
    color: "#5fe8ac",
    content: "ERP、BOM等信息的追朔性差，信息统计滞后，物料及库存管理难度大    ",
  },
];

export const energyPainPoints = [
  {
    title: "能源部分，能源痛点",
    order: 1,
    // img: require("/public/image/资源130.png"),
    content:
      "轨道交通范围大，对设备能耗缺乏数据展示及统计分析，存在大量能源无形浪费    ",
  },
  {
    title: "能源部分，能源痛点",
    order: 2,
    // img: require("/public/image/资源129.png"),
    content:
      "电网每日产生海量数据，数据价值挖掘少，大量数据处于“沉睡状态”，亟待发挥作用    ",
  },
  {
    title: "能源部分，能源痛点",
    order: 3,
    // img: require("/public/image/资源128.png"),
    content:
      "在二维中表达缺乏层次感，在数量繁多、关系复杂的空间信息面前，二维空间分析具有局限性    ",
  },
  {
    title: "能源部分，能源痛点",
    order: 4,
    // img: require("/public/image/资源127.png"),
    content:
      "电网业务涵盖环节多，影响范围广，易受环境因素影响，对于电网安全稳定运行提出更高要求    ",
  },
  {
    title: "能源部分，能源痛点",
    order: 5,
    // img: require("/public/image/资源126.png"),
    content:
      "随着轨道交通建设的发展，涉及的里程、站点数飞速增涨，需要管理的设备繁杂    ",
  },
  {
    title: "能源部分，能源痛点",
    order: 6,
    // img: require("/public/image/资源125.png"),
    content:
      "随着轨道交通建设的发展，涉及的里程、站点数飞速增涨，需要管理的设备繁杂    ",
  },
];
